type ChatRole = 'user' | 'assistant' | 'system'

export const AI_CHAT_COMPRESS_STREAM_CONTENT_TYPE = 'text/event-stream; charset=utf-8'

const LEGACY_COMPRESSION_FAILURE_PATTERNS = [
  /^(手动压缩失败|自动压缩失败)[:：]/u,
  /本机服务连接中断/u,
  /Failed to fetch/iu,
  /最后一条(?:助手|系统)消息.*?(手动压缩失败|自动压缩失败)/u,
  /系统压缩工具存在临时中断/u,
  /该错误未影响前述任务输出/u,
]

export function isAiChatCompressionFailureContent(role: ChatRole, content: string) {
  if (role !== 'assistant') return false
  return /^(手动压缩失败|自动压缩失败)[:：]/u.test(content.trim())
}

function isLegacyCompressionFailureSummaryLine(line: string) {
  const normalized = line.trim()
  if (!normalized) return false
  return LEGACY_COMPRESSION_FAILURE_PATTERNS.some((pattern) => pattern.test(normalized))
}

export function sanitizeAiChatCompressedSummary(value: unknown) {
  if (typeof value !== 'string') return ''
  const lines = value
    .replace(/\r\n?/g, '\n')
    .split('\n')
    .filter((line) => !isLegacyCompressionFailureSummaryLine(line))
  return lines.join('\n').replace(/\n{3,}/g, '\n\n').trim()
}

export function encodeAiChatCompressionStreamEvent(
  event: 'ready' | 'ping' | 'done' | 'error',
  payload: Record<string, unknown>,
) {
  return `event: ${event}\ndata: ${JSON.stringify(payload)}\n\n`
}
